export const pageRoutes = {
  studentDashboard: "student-dashboard",
  dashboard: "dashboard",
  webinars: "webinars",
  gigs: "gigs",
  opportunities: "opportunities",
  deliverables: "deliverables",
  reviews: "reviews",
  course: "course",
  lesson: "lesson",
  announcements: "announcements",
  aiReviewer: "aiReviewer",
  history: "history",
  historyDetail: "history-detail",
  qa: "qa",
  // Renamed to "profile" in the UI; the key stays `settings` so existing
  // imports keep working. /settings still resolves via a redirect.
  settings: "profile",
  legacySettings: "settings",
  support: "support",
  unauthorized: "unauthorized",
  login: "login",
  students: "students",
  studentDetails: "details",
  instructors: "instructors",
  instructorDetails: "details",
  aiInterviewing: "aiInterviewing",
  controlPanelStudents: "control-panel/cp-students",
  controlPanelInstructors: "control-panel/cp-instructors",
  controlPanelCreateNewGroup: "control-panel/create-new-group",
  controlPanelJobProfile: "job-profile",
  controlPanelCoachRound: "coach-round",
  controlPanelUploadStudents: "upload-students",
  controlPanelUpdateStudentsType: "update-students-type",
  controlPanelUpdateStudentsRole: "update-students-role",
  controlPanelWebinars: "control-panel/cp-webinars",
  controlPanelGigs: "control-panel/cp-gigs",
  controlPanelAnnouncements: "control-panel/cp-announcements",
  gigsProposals: "gigs-proposals",
  controlPanelLeads: "control-panel/leads",
};
export const pageLinks = {
  login: "/login",
  landingPage: "/",
};
export const roles = {
  studentRole: "student",
  studentArchiveRole: "student-Archive",
  instructorRole: "instructor-All",
  webinarInstructorRole: "instructor-Webinar",
  qaInstructorRole: "instructor-Q/A",
  admin: "staff",
  adminEditor: "staff-editor",
};

export const queryKeys = {
  getAllAnnouncements: "getAllAnnouncements",
};

// The filter toolbar shared by every admin list page: one surface holding the
// filter controls and the search box, sitting directly above its table.
export const dashboardFilterWrapperClassname =
  "mb-4 w-full flex md:flex-row flex-col-reverse items-start justify-between gap-4 rounded-20 border border-blue-100 bg-white p-[1rem]";
